/*
 * @Author: 张丛 nhsoft.zhangc
 * @Date: 2024-05-27 14:18:02
 * @LastEditors: 张丛 nhsoft.zhangc
 * @LastEditTime: 2024-05-27 14:58:16
 * @FilePath: \mars-front-admin-chain-stock\src\models\purchasing\supply\supply.model.ts
 * @Description: 物品供货关系model
 */
import type { ISupplyModel, ISupplyStore } from '@monorepo/types/purchasing/supply/supply.types';

const initState: ISupplyStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    offset: 0,
    limit: 50,
    location_id_list: [],
  },
};

const SupplyStore: ISupplyModel = {
  namespace: 'supplyStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      return {
        ...state,
        tableList: payload.data,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default SupplyStore;
